import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

import * as copy from 'copy-to-clipboard';
import { TraaqrTag } from '../../../../core/models/traaqrTag';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { TraaqrTagDao } from '../../../../core/services/dao/traaqrTagDao';

@Component({
  selector: 'app-installation',
  templateUrl: './installation.component.html',
  styleUrls: ['./installation.component.scss']
})
export class InstallationComponent implements OnInit, OnDestroy {
  traaqrTag: TraaqrTag;
  embedCode: string;
  detected = false;

  private subs = [];

  constructor(
    private route: ActivatedRoute,
    private apiHelper: ApiHelper,
    private traaqrTagDao: TraaqrTagDao,
    public snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit() {
    if (this.route.snapshot.params.token) {
      if (this.route.snapshot.data.portal) {
        this.traaqrTag = this.route.snapshot.data.portal[0];
        this.detected = this.traaqrTag.embedDetected;
        // let sub = this.traaqrTagDao.getStatus(this.traaqrTag.token).subscribe(res => {
        //   if (res) {
        //     this.detected = res;
        //   }
        // });
        // this.subs.push(sub);
        this.embedCode = `<script async src="${this.apiHelper.embedUrl}/${this.traaqrTag.token}/page.js"></script>`;
      } else {
        let tagSub = this.traaqrTagDao.loadByToken(this.route.snapshot.params.token).subscribe(tag => {
          this.traaqrTag = tag;
          this.detected = this.traaqrTag.embedDetected;
          this.embedCode = `<script async src="${this.apiHelper.embedUrl}/${this.traaqrTag.token}/page.js"></script>`;
        //   let sub = this.traaqrTagDao.getStatus(this.traaqrTag.token).subscribe(res => {
        //     if (res) {
        //       this.detected = res;
        //     }
        //   });
        //   this.subs.push(sub);
        });
        this.subs.push(tagSub);
      }
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  copyEmbedCode() {
    let copied = copy(this.embedCode);
    if (copied) {
      this.snackBar.open('Embed Code Copied', 'Dismiss', {
        duration: 5000,
        verticalPosition: 'top'
      });
    }
  }

  refreshData() {
    // let tagSub = this.traaqrTagDao.getStatus(this.traaqrTag.token).subscribe(res => {
    //   if (res) {
    //     this.snackBar.open('Embed Code has been successfully detected', 'OK', {
    //       duration: 5000,
    //       verticalPosition: 'top'
    //     });
    //     this.router.navigate(['manage/tags']);
    //   } else {
    //     this.snackBar.open('Embed Code has not been detected.', 'Dismiss', {
    //       duration: 10000,
    //       verticalPosition: 'top'
    //     });
    //   }
    // });
    // this.subs.push(tagSub);
  }
}
